<template>
  <div class="box">
    <h4 class="title is-6">Hotspots by Province</h4>
    <canvas ref="canvasEl"></canvas>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { Chart } from "chart.js/auto";

const canvasEl = ref(null);
let chartInstance = null;

// 🔥 Mock Data จำลอง hotspot รายจังหวัด
const mockData = [
  { province: "Chiang Mai", count: 320 },
  { province: "Lampang", count: 210 },
  { province: "Tak", count: 180 },
  { province: "Nan", count: 150 },
  { province: "Mae Hong Son", count: 260 },
];

onMounted(() => {
  chartInstance = new Chart(canvasEl.value, {
    type: "bar",
    data: {
      labels: mockData.map((item) => item.province),
      datasets: [
        {
          label: "Hotspot Count",
          data: mockData.map((item) => item.count),
          backgroundColor: [
            "#ff3860",
            "#ff9f40",
            "#ffcd56",
            "#36a2eb",
            "#9966ff",
          ],
        },
      ],
    },
    options: {
      responsive: true,
      plugins: {
        legend: {
          display: true,
        },
      },
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    },
  });
});

onBeforeUnmount(() => {
  if (chartInstance) {
    chartInstance.destroy();
  }
});
</script>
